import React from 'react';
import ReactDOM from 'react-dom';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { Provider } from 'react-redux';
import store from 'src/redux/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './rsuite.css';
import ErrorBoundary from './ErrorBoundary/index';
import 'rsuite-table/dist/css/rsuite-table.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </StyledEngineProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
